export const FISCAL_YEAR_REQUEST = 'FISCAL_YEAR_REQUEST';
export const FISCAL_YEAR_SUCCESS = 'FISCAL_YEAR_SUCCESS';
export const FISCAL_YEAR_FAIL = 'FISCAL_YEAR_FAIL';

